import {
  RowDataReducerState,
  RowDataReducerAction,
} from "../../../../../types";
import { isNewRecord } from "../../../helpers";

export const getCashInBankReportNumber = (
  propertyKey: string,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  const { rowData, rowDataList, resetState } = rowDataReducerState;

  if (isNewRecord(rowData)) {
    const existingReportNumbers = rowDataList.map(
      (row) => row[propertyKey] as number,
    );
    const nextReportNumber =
      existingReportNumbers.length > 0
        ? Math.max(...existingReportNumbers) + 1
        : 1;

    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey: propertyKey,
        newFieldValue: nextReportNumber,
      },
    });

    // Need this to manage `Clear Changes` button state in New/Edit/Clone entries
    dispatch({
      type: "UPDATE_ROW_DATA_REDUCER_STATE",
      payload: {
        resetState: {
          newEntryRowData: {
            ...resetState?.newEntryRowData,
            [propertyKey]: nextReportNumber,
          },
          rowData: {
            ...rowData,
            [propertyKey]: nextReportNumber,
          },
        },
      },
    });
  }
};
